import { Component, OnInit, Input } from '@angular/core';
import { SeoContent } from '@apply4u/models/seoContent';
import { ContextService } from '@apply4u/services/context-service';

@Component({
  selector: 'seo-content-links',
  templateUrl: './seo-content-links.component.html',
  styleUrls: ['./seo-content-links.component.css']
})
export class SeoContentLinksComponent implements OnInit {
  @Input() SeoContent: SeoContent;
  @Input() IndustryName: string = "";
  SubIndustryShowHide: boolean = false;
  SeoIndustryName: string = "";
  ShowItem: boolean = false;

  constructor(public ContextService: ContextService) {
  }

  ngOnInit() {
  }

  SubIndustriesReadMore(): void {
    this.SubIndustryShowHide = !this.SubIndustryShowHide;
  }

  ReadMoreLess(): void {
    this.ShowItem = !this.ShowItem;
  }
}
